<template>
<div class="content-i">
    <div class="content-box">

        <!--START - Recent Ticket Comments-->
        <div class="element-wrapper">
            <h6 class="element-header">Imports</h6>
            <div class="element-box-tp">
                <EmptyState v-if="!pagination.data" >
                    <div slot="empty_state_text">
                       There are no import reports
                    </div>
                </EmptyState>
                <Loader v-if="isLoading == false" />
                <div class="table-responsive" v-else>
                    <table class="table table-padded">
                        <thead>
                            <tr>
                                <th>Import Code</th>
                                <th>Import Type</th>
                                <th>Requested By</th>
                                <th>Import Details</th>
                                <th>Import Date</th>
                                <th>Rows</th>
                                <th>Import Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="report in pagination.data">
                                <td>{{report.code}}</td>
                                <td>
                                    <div class="capitalize">{{report.import_type .replace(/_/g, ' ')}}</div>
                                </td>
                                <td>
                                    <div class="user-with-avatar" v-if="report.user_name"><img alt="" :src="report.user_avatar"><span>{{report.user_name}}</span></div>
                                    <div>{{report.created_by}}</div>
                                </td>
                                <td>{{report.filename}}</td>
                                <td><span>{{report.created_at}}</span></td>
                                <td >{{report.rows || 0}}</td>
                                <td class="nowrap"> <div v-html="formatReportStatus(report)"></div></td>
                                <td class="row-actions">
                                   
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getExportedReports()" :offset="5"></Pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/Loader'

export default {
  components: {
    Pagination,
    EmptyState,
    Loader
  },
  data: function () {
    return {
      isLoading: true,
      pagination: {
        'current_page': 1
      }
    }
  },
  mounted: function () {
    var self = this
    this.getExportedReports()

    var channel = this.$pusher.subscribe('export')
    console.log(channel)
    channel.bind('complete', function (data) {
      self.getExportedReports()
    })
  },
  methods: {
    getExportedReports: function () {
      var self = this
      const url = '/impexdesk/imports?page=' + this.pagination.current_page
      self.isLoading = true
      this.$http.post(url, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          console.log(response)
          self.pagination = response.data.imports
          self.isLoading = true
        })
        .catch(function (error) {
          console.log(error)
          self.isLoading = true
        })
    },
    formatReportStatus: function (report) {
      var response = ''
      if (report.status == 2) {
        response = '<span class="status-pill smaller red"></span><span>Failed</span>'
        return response
      }
      if (report.status == 0) {
        response = '<div class="loader12"></div>'
      } else {
        response = '<span class="status-pill smaller green"></span><span>Success</span>'
      }

      return response
    }
  }
}
</script>
